export class ScheduleMethodType {
    static Start = 1;
    static Stop = 2;
    static Pause = 3;
    static Resume = 4;
}

export class RunningType {
    static Multiple = 1;
    static NotMultiple = 0;
}

export class ScheduleConstants {
    static ScheduleMethodTypeDataSource = [
        { value: ScheduleMethodType.Start, label: 'Bắt đầu', labelStatus: 'Đang chạy', styleClass: 'start', confirmMessage: 'Bạn có muốn khởi động công việc này không?', confirmHeader: 'Xác nhận khởi động' },
        { value: ScheduleMethodType.Stop, label: 'Dừng', labelStatus: 'Đã dừng', styleClass: 'stop', confirmMessage: 'Bạn có muốn dừng công việc này không?', confirmHeader: 'Xác nhận dừng' },
        { value: ScheduleMethodType.Pause, label: 'Tạm dừng', labelStatus: 'Tạm dừng', styleClass: 'pause', confirmMessage: 'Bạn có muốn tạm dừng công việc này không?', confirmHeader: 'Xác nhận tạm dừng' },
        { value: ScheduleMethodType.Resume, label: 'Tiếp tục', labelStatus: 'Tiếp tục', styleClass: 'resume', confirmMessage: 'Bạn có muốn tiếp tục công việc này không?', confirmHeader: 'Xác nhận tiếp tục' }
    ]

    static RunningTypeDataSource = [
        { value: RunningType.NotMultiple, label: 'Tuần tự', labelDescription: 'Chỉ cho phép chạy từng lịch trình trong 1 thời gian' },
        { value: RunningType.Multiple, label: 'Song song', labelDescription: 'Cho phép nhiều lịch trình chạy cùng 1 thời gian' }
    ]
}
